import N from "../../../@babel/runtime/helpers/esm/typeof.mjs";
import y from "../../../rc-util/es/Children/toArray.mjs";
import t, { noteOnce as g } from "../../../rc-util/es/warning.mjs";
import * as w from "react";
import { isMultiple as z } from "../BaseSelect.mjs";
import { toArray as F } from "./commonUtil.mjs";
import { convertChildrenToData as G } from "./legacyUtil.mjs";
function R(e) {
  var o = e.mode, c = e.options, i = e.children, s = e.backfill, p = e.allowClear, r = e.placeholder, l = e.getInputElement, f = e.showSearch, x = e.onSearch, k = e.defaultOpen, O = e.autoFocus, S = e.labelInValue, m = e.value, V = e.inputValue, A = e.optionLabelProp, v = z(o), I = f !== void 0 ? f : v || o === "combobox", h = c || G(i);
  if (t(o !== "tags" || h.every(function(n) {
    return !n.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), o === "tags" || o === "combobox") {
    var E = h.some(function(n) {
      return n.options ? n.options.some(function(u) {
        return typeof ("value" in u ? u.value : u.key) == "number";
      }) : typeof ("value" in n ? n.value : n.key) == "number";
    });
    t(!E, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (t(o !== "combobox" || !A, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), t(o === "combobox" || !s, "`backfill` only works with `combobox` mode."), t(o === "combobox" || !l, "`getInputElement` only work with `combobox` mode."), g(o !== "combobox" || !l || !p || !r, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), x && !I && o !== "combobox" && o !== "tags" && t(!1, "`onSearch` should work with `showSearch` instead of use alone."), g(!k || O, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), m != null) {
    var C = F(m);
    t(!S || C.every(function(n) {
      return N(n) === "object" && ("key" in n || "value" in n);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), t(!v || Array.isArray(m), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (i) {
    var a = null;
    y(i).some(function(n) {
      if (!/* @__PURE__ */ w.isValidElement(n) || !n.type)
        return !1;
      var u = n, d = u.type;
      if (d.isSelectOption)
        return !1;
      if (d.isSelectOptGroup) {
        var P = y(n.props.children).every(function(b) {
          return !/* @__PURE__ */ w.isValidElement(b) || !n.type || b.type.isSelectOption ? !0 : (a = b.type, !1);
        });
        return !P;
      }
      return a = d, !0;
    }), a && t(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(a.displayName || a.name || a, "`.")), t(V === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function T(e, o) {
  if (e) {
    var c = function i(s) {
      for (var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = 0; r < s.length; r++) {
        var l = s[r];
        if (l[o == null ? void 0 : o.value] === null)
          return t(!1, "`value` in Select options should not be `null`."), !0;
        if (!p && Array.isArray(l[o == null ? void 0 : o.options]) && i(l[o == null ? void 0 : o.options], !0))
          break;
      }
    };
    c(e);
  }
}
export {
  R as default,
  T as warningNullOptions
};
//# sourceMappingURL=warningPropsUtil.mjs.map
